import { MonitorCellphoneStarIcon } from './MonitorCellphoneStarIcon';

/**
 * author: Google
 * id 6665F86B-B97E-4AB8-8476-06B045706183
 * name monitor-cellphone-star
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/monitor-cellphone-star.svg
 * tags
 * - Cellphone / Phone 
 * - Device / Tech 
 */
export const MonitorSmartphoneStarIcon = MonitorCellphoneStarIcon;
export default MonitorSmartphoneStarIcon